<template>
	<div class="max-width">
		<div class="subs">
			<router-link to="/" class="subs__links">Home</router-link>
			<router-link to="/help-center/" class="subs__links"
				>Help Center</router-link
			>
			<span>Force</span>
		</div>

		<div class="sh-documentation-theme">
			<aside class="sh-documentation-theme__sidebar">
				<div class="sh-documentation-theme__sidebar-inner">
					<div class="sh-documentation-theme__sidebar-nav">
						<div class="sh-documentation-theme__sidebar-wrapper">
							<ul class="sh-documentation-theme__sidebar-list">
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#theme-settings">General Settings</a>
									<ul class="sh-documentation-theme__sidebar-sublist">
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#color-swatches">Color Swatches</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#product-card">Product Card</a>
											<ul class="sh-documentation-theme__sidebar-sublist">
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#custom-badges">Custom Product Badges</a>
												</li>
											</ul>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#pagination">Pagination</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#back-to-top">Back to Top</a>
										</li>
									</ul>
								</li>

								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#header-group">Header Group</a>
									<ul class="sh-documentation-theme__sidebar-sublist">
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#announcement-bar">Announcement Bar</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#header">Header</a>
											<ul class="sh-documentation-theme__sidebar-sublist">
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#header-search">Search Modal</a>
												</li>
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#aside-menu">Aside Menu</a>
												</li>
											</ul>
										</li>
									</ul>
								</li>
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#overlay-group">Overlay Group</a>
									<ul class="sh-documentation-theme__sidebar-sublist">
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#popup">Popup</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#notification-banner">Notification Banner</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#notification-bar">Notification Countdown</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#age-verifier">Age Verification Popup</a>
										</li>
									</ul>
								</li>
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#footer-group">Footer Group</a>
									<ul class="sh-documentation-theme__sidebar-sublist">
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#footer">Footer</a>
										</li>
									</ul>
								</li>
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#all-sections">Sections</a>
									<ul class="sh-documentation-theme__sidebar-sublist">
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#sections-general-settings">General Settings</a>
											<ul class="sh-documentation-theme__sidebar-sublist">
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#section-margin">Section Margin</a>
												</li>
											</ul>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#recomended-slider">Recomended Slider</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#featured-product">Featured Product</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#rte">Rich Text</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#image-with-text">Image with Text</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#slideshow">Slideshow</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#multicolumn">Multicolumn</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#collapsible-content">Collapsible Content</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#collection-grid">Collection Grid</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#promo-banner">Promo Banner</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#before-after">Before / After</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#featured-blog">Featured Blog</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#featured-ticker">Featured Ticker</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#collections-list">Collections List</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#countdown">Countdown</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#product-carousel">Popular Products</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#product-markers">Product Markers</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#products-slider">Products Slider</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#testimonials">Testimonials</a>
										</li>
									</ul>
								</li>
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#page">Pages</a>
									<ul class="sh-documentation-theme__sidebar-sublist">
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#product-page">Product Page</a>
											<ul class="sh-documentation-theme__sidebar-sublist">
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#product-information">Product Information</a>
												</li>

												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#product-recommendations"
														>Product Recommendations</a
													>
												</li>

												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#variant-picker">Variant Picker</a>

													<ul class="sh-documentation-theme__sidebar-sublist">
														<li
															class="sh-documentation-theme__sidebar-sublist-item"
														>
															<a href="#variant-picker-pills">Pills</a>
														</li>

														<li
															class="sh-documentation-theme__sidebar-sublist-item"
														>
															<a href="#variant-picker-dropdown">Dropdown</a>
														</li>
													</ul>
												</li>
											</ul>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#collections-page">Collections Page</a>
											<ul class="sh-documentation-theme__sidebar-sublist">
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#collection-banner">Collection Banner</a>
												</li>
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#product-grid">Product Grid</a>
												</li>
											</ul>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#cart">Cart</a>
											<ul class="sh-documentation-theme__sidebar-sublist">
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#cart-shipping">Free shipping message</a>
												</li>
											</ul>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#blog">Blog</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#blog-post">Blog Post</a>
										</li>
									</ul>
								</li>
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#import-demos">Importing Our Demos</a>
									<ul class="sh-documentation-theme__sidebar-sublist">
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#demos-structure">Demos Structure</a>
										</li>
									</ul>
								</li>
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#support">Support</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</aside>
			<div class="sh-documentation-theme__content">
				<div class="sh-content">
					<h1 id="started">Force</h1>
					<p>
						Below you’ll find a list of articles broken down by sub topics that
						cover each and every aspect of your theme. We regularly maintain our
						documentation in collaboration with our support staff.
					</p>

					<!------------------------------ THEME SETTINGS (START) ------------------------------>

					<h2 id="theme-settings">Theme Settings</h2>

					<p>With the Theme settings, you can:</p>
					<ul>
						<li>Manage color schemes</li>
						<li>Customize the appearance of text elements</li>
						<li>Upload a favicon</li>
						<li>Control the appearance of product cards</li>
						<li>
							Manage the Quick View and Quick Add buttons inside product cards
						</li>
						<li>Enable and customize color swatches</li>
						<li>
							Manage Predictive Search (please note: Predictive Search is not
							supported in Shopify for some languages)
						</li>
						<li>Enable and customize the Cart Drawer for faster purchases</li>
						<li>
							Customize pagination (limited to pages specified in the notes)
						</li>
						<li>Add links to your social media</li>
						<li>
							Apply custom CSS styles if you need to override the theme's
							default styles
						</li>
					</ul>
					<figure>
						<img src="/assets/imgs/docs/force/theme_settings.png" />
					</figure>

					<h3 id="color-swatches">Color Swatches</h3>
					<p>
						To enable and edit Color swatches, navigate to Theme settings >
						Color swatch.
					</p>
					<p>
						If product color options are added via
						<a
							href="https://help.shopify.com/en/manual/custom-data/metafields/category-metafields/using-category-metafields"
							aria-label="Category metafields in Shopify Help Center"
							target="_blank"
							><b>category metafields</b></a
						>, they will <b>automatically</b> appear in the following locations:
					</p>
					<ul>
						<li>On the product page</li>
						<li>In the featured product section</li>
						<li>
							On the collection page in filters. Customize filters with the
							<a
								href="https://help.shopify.com/en/manual/online-store/search-and-discovery/filters"
								aria-label="Category metafields in Shopify Help Center"
								target="_blank"
								>Search and Discovery app</a
							>.
						</li>
					</ul>
					<p>
						If the product color option is added as a <b>custom option</b>, the
						Swatch trigger field must be filled in to display color swatches.
						You can also add custom colors by adding their name and color in HEX
						format.
					</p>
					<p>
						To display color swatches on the <b>product card</b>, the Swatch
						trigger field must also be filled in.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/color_swatches.png" />
					</figure>

					<h3 id="product-card">Product Card</h3>
					<p>
						In the Theme settings > Product card section, you can customize the
						appearance of product cards across the entire theme.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/product_card.png" />
					</figure>
					<ol>
						<li>
							The <b>Image ratio</b> setting applies a consistent image aspect
							ratio for product images in all cards.
						</li>
						<li>
							The <b>Hover effect</b> setting lets you choose the animation type
							when hovering over a product card. If you select
							<b>Show second image</b> but the product has only one image, the
							<b>Image zoom</b> effect will be applied automatically.
						</li>
						<li>
							The <b>Swatch type</b> setting allows you to choose how color
							swatches are displayed on product cards. If
							<b>Variant image</b> is selected, the swatch will show the variant
							image; if no image is available, it will automatically fall back
							to the <b>Color</b> type.
						</li>
					</ol>

					<h3 id="custom-badges">Custom Product Badges</h3>
					<p>
						To enable and edit Custom badges, navigate to Theme settings >
						Product card.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/custom_badges_4.png" />
					</figure>
					<p>The next step is to add metafields to the products.</p>
					<p>To add and edit metafields, follow these steps:</p>
					<ol>
						<li>
							Navigate to Settings > Metafields and metaobjects in the Admin
							panel > Select Products > Click the button "Add definition".
							<figure>
								<img src="/assets/imgs/docs/force/custom_badges_1.png" />
							</figure>
						</li>
						<li>
							Fill the fields. In the Name field enter "Badges" so that
							"custom.badges" appears in the Namespace and Key field. In the
							Select type field select "Single line text" and "List of values."
							<figure>
								<img src="/assets/imgs/docs/force/custom_badges_2.png" />
							</figure>
						</li>
						<li>
							Navigate to the product and add information below.
							<figure>
								<img src="/assets/imgs/docs/force/custom_badges_3.png" />
							</figure>
						</li>
					</ol>

					<h3 id="pagination">Pagination</h3>
					<p>
						For collection list pages, product list pages, the blog page and the
						search page, you can configure the pagination type. To select
						pagination type, navigate to Theme settings > Pagination >
						Pagination type.
					</p>
					<ol>
						<li>
							Classic pagination type
							<figure>
								<img src="/assets/imgs/docs/force/pagination_1.png" />
							</figure>
						</li>
						<li>
							Load more type
							<figure>
								<img src="/assets/imgs/docs/force/pagination_2.png" />
							</figure>
						</li>
						<li>
							Infinite scroll type
							<figure>
								<img src="/assets/imgs/docs/force/pagination_3.png" />
							</figure>
						</li>
					</ol>

					<h3 id="back-to-top">Back to Top</h3>
					<p>
						To enable Back to Top button, navigate to Theme settings > Advanced.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/back_to_top.png" />
					</figure>

					<!------------------------------ THEME SETTINGS (END) ------------------------------>

					<!------------------------------ HEADER GROUP (START) ------------------------------>

					<h2 id="header-group">Header Group</h2>

					<p>Sections that are used on all pages by default.</p>

					<h3 id="announcement-bar">Announcement Bar</h3>
					<p>
						The announcement bar appears at the top of every page and includes
						countdown timer, custom messages with optional links. It's good to
						use for promoting sales or need-to-know updates.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/ann_bar_1.png" />
					</figure>
					<ol>
						<li>
							<b>Color scheme</b> selector allows you to change the color
							scheme. You can change the colors in the <b>Theme settings</b>.
						</li>
						<li>
							<b>Minimum height</b> slider allows you to change the announcement
							height only on desktop devices.
						</li>
						<li>
							<b>Minimum height on mobile devices</b> slider allows you to
							change the announcement height only on mobile devices.
						</li>
						<li>
							<b>Main text</b> field allows you to add and edit text for display
							on desktop devices.
						</li>
						<li>
							<b>Main text om mobile</b> field allows you to add and edit text
							for display on mobile devices.
						</li>
						<li>
							<b>Countdown timer options</b> allow you to place and manage a
							countdown timer.
						</li>
					</ol>

					<h3 id="header">Header</h3>
					<p>You can customize the header.</p>
					<figure>
						<img src="/assets/imgs/docs/force/header_1.png" />
					</figure>
					<ol>
						<li>
							The <b>Desktop header layout</b> setting allows you to choose
							different element layouts within the header on desktop devices..
						</li>
						<li>
							Use the <b>Sticky header</b> field to select a variant of the
							header when user scrolls in page.
						</li>
						<li><b>Enable search</b> allows you to add search interface.</li>
						<li>
							<b>Logo</b> options allow you to select and customize the
							appearance of the logo that will be displayed in the Header.
						</li>
						<li>
							<b>Menu</b> options allow you to select the primary and secondary
							menus, set a highlighted link in the primary menu, and provide
							additional contact information.
						</li>
						<li>
							<b>Main buttons</b> options allow you to manage the display of the
							cart, account, region/language switcher, and color scheme switcher
							buttons.
						</li>
						<li>
							<b>Shop mega menu button </b> options allow you to configure the
							display of the Shop All button, which is linked to the
							<a href="#shop-mega-menu" aria-label="Shop mega menu"
								>Shop Mega Menu section</a
							>. This button is intended for use in the store’s global catalog
							menu. If it’s not linked to the Shop Mega Menu section, it will
							direct users to the page specified in the Button link field.
						</li>
					</ol>

					<h4 id="header-search">Search Modal</h4>
					<p>
						In the Search modal, you can add an <b>additional menu</b> for quick
						customer access to your selected pages, a list of
						<b>popular products</b>, as well as <b>promo banner</b> that allow
						you to configure a promotional banner where you can set an image or
						video and display a message about a collection or promotion. The
						Search modal will appear beneath the search interface when the
						search input is focused.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/header_search_1.png" />
					</figure>
					<figure>
						<img src="/assets/imgs/docs/force/search_modal_1.png" />
					</figure>
					<p>
						In this theme, you can use a <b>predictive search</b>. It is enabled
						by default for header, but you can disable it in the Theme settings
						> Predictive search.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/predictive_search_1.png" />
					</figure>

					<h4 id="aside-menu">Aside Menu</h4>
					<p>
						In the Theme settings > Aside Menu, you can customize the appearance
						of <b>aside menu</b>.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/aside_menu_1.png" />
					</figure>

					<!------------------------------ HEADER GROUP (END) ------------------------------>

					<!------------------------------ OVERLAY GROUP (START) ------------------------------>

					<h2 id="overlay-group">Overlay Group</h2>

					<h3 id="popup">Popup</h3>
					<p>
						In the Popup settings, you can change layout, add image, subscribe
						form, customize position, open and exit animations and other
						options.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/popup_1.png" />
					</figure>
					<h3 id="notification-banner">Notification Banner</h3>
					<p>
						In the Notification Banner settings, you can change layout, add
						image, texts, customize banner position, change open and exit
						animations and other options.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/notification_banner_1.png" />
					</figure>

					<h3 id="notification-bar">Notification Countdown</h3>
					<p>
						This section allows you to display a bar with a message or
						notification at the top or bottom of the page, spanning its full
						width.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/notification_countdown_1.png" />
					</figure>

					<h3 id="age-verifier">Age Verification Popup</h3>
					<p>
						An Age verification popup is a prompt that appears on a website to
						confirm the user's age before accessing restricted content. In the
						Age verification popup settings, you can change customize text and
						buttons.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/age_verification_1.png" />
					</figure>

					<!------------------------------ OVERLAY GROUP (END) ------------------------------>

					<!------------------------------ FOOTER GROUP (START) ------------------------------>

					<h2 id="footer-group">Footer Group</h2>

					<p>Sections is used on all pages by default.</p>

					<h3 id="footer">Footer</h3>
					<p>
						Footer appears at the bottom of every page. You can customize it to
						fit your brand and product offerings.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/footer_1.png" />
					</figure>
					<ol>
						<li>
							<b>Ticker text</b> field enables the display of a scrolling text
							line in the footer.
						</li>
						<li>
							<b>Ticker speed</b> field allows you to adjust the scrolling speed
							of the ticker text in the footer.
						</li>
						<li>
							<b>Country/region selector</b> field enables the display of the
							region selector in the footer.
						</li>
						<li>
							<b>Language selector</b> field enables the display of the language
							selector in the footer.
						</li>
						<li>
							<b>Payment methods</b> field enables the display of payment
							methods in the bottom line of the footer.
						</li>
						<li><b>Copyright</b> allow to show info about copyright.</li>
						<li>
							<b>Policy Links</b> field enables the display of the policies
							links in the footer.
						</li>
						<li>
							Block <b>Menu</b> allows you to select menus, which will be
							displayed on the top line of the footer.
						</li>
					</ol>

					<!------------------------------ FOOTER GROUP (END) ------------------------------>

					<!------------------------------ SECTIONS (START) ------------------------------>

					<h2 id="all-sections">Sections</h2>
					<p>
						The theme contains several customizable sections that you can add to
						your page in any order.
					</p>

					<h3 id="sections-general-settings">General Settings</h3>
					<p>Settings that are used in almost all sections.</p>

					<h3 id="section-margin">Section Margin</h3>
					<p>Allows you to change the top and bottom margin in the section</p>
					<ol>
						<li>
							<b>Top margin</b> slider allows you to change the top margin in
							the section.
						</li>
						<li>
							<b>Bottom margin</b> slider allows you to change the bottom margin
							in the section.
						</li>
					</ol>
					<figure>
						<img src="/assets/imgs/docs/force/margin_1.png" />
					</figure>

					<h3 id="recomended-slider">Recomended Slider</h3>
					<p>
						The section allows you to display products from a selected
						collection. Additionally, you can display up to 2 promo cards or a
						collection card.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/recomended_slider_1.png" />
					</figure>
					<ol>
						<li><b>Image</b> field allows you to add a background image.</li>
						<li>
							<b>Author Image</b> field allows you to add an author image.
						</li>
						<li>
							<b>Author name</b> field allows you to set the name of the author
							that will be displayed in the section.
						</li>
						<li>
							<b>Author position</b> field allows you to set the position, role,
							or title of the author.
						</li>
						<li>
							<b>Products</b> setting allows you to select and display specific
							products in the section.
						</li>
						<li>
							<b>Columns per row</b> setting allows you to define how many
							columns of content or products will be displayed in a single row.
						</li>
						<li>
							<b>Enable autoplay</b> option allows you to automatically start
							sliding or rotating content (such as a carousel or slider) without
							user interaction.
						</li>
						<li>
							<b>Speed sliding</b> setting allows you to adjust how fast the
							slides transition from one to another.
						</li>
						<li>
							<b>Delay sliding</b> setting allows you to set the time interval
							before switching to the next slide.
						</li>
						<li>
							<b>Product Card Options</b><br />
							<ol>
								<li>
									<b>Image aspect ratio</b> allows you to set the proportion
									(e.g. square, portrait, landscape) of the product image.
								</li>
								<li>
									<b>Image fit</b> allows you to control how the product image
									is fitted inside its container (e.g. cover, contain).
								</li>
								<li>
									<b>Show second image on hover</b> allows you to display an
									alternative product image when hovering over the product card.
								</li>
								<li>
									<b>Show vendor</b> allows you to display the product vendor
									(brand).
								</li>
								<li>
									<b>Show collection</b> allows you to display the collection to
									which the product belongs.
								</li>
								<li>
									<b>Show description</b> allows you to display the product
									description in the card.
								</li>
								<li>
									<b>Show swatches</b> allows you to display product variant
									swatches (such as color options).
								</li>
							</ol>
						</li>
					</ol>

					<h3 id="featured-product">Featured Product</h3>
					<p>
						In this section, you can display a single product and provide
						information about it. This section is similar to
						<a href="#product-information">Product information</a>, but with
						limited functionality.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/featured_product_1.png" />
					</figure>

					<h3 id="rte">Rich text</h3>
					<p>This section allows you to add Rich text content block.</p>
					<figure>
						<img src="/assets/imgs/docs/force/rich_text_1.png" />
					</figure>
					<ol>
						<li>
							<b>Heading</b> allows you to add a heading and customize its size.
						</li>
						<li>
							<b>Heading size</b> allows you to select the display size of the
							heading (e.g. small, medium, large).
						</li>
						<li><b>Subheading</b> allows you to add a subheading.</li>
						<li>
							<b>Enable subheading animation</b> allows you to enable animation
							effects for the subheading when it appears.
						</li>
						<li>
							<b>Description</b> allows you to add descriptive text (rich text
							content).
						</li>
					</ol>

					<h3 id="image-with-text">Image with Text</h3>
					<p>This section allows you to add image with text (content) block.</p>
					<figure>
						<img src="/assets/imgs/docs/force/image_with_text_1.png" />
					</figure>
					<ol>
						<li>
							<b>Image options</b><br />
							<ol>
								<li><b>Image</b> allows you to add an image.</li>
								<li>
									<b>Image aspect ratio</b> allows you to set the proportion
									(e.g. square, portrait, landscape) of the image.
								</li>
								<li>
									<b>Image fit</b> allows you to control how the image is fitted
									inside its container (e.g. cover, contain).
								</li>
								<li>
									<b>Show second image on hover</b> allows you to display an
									alternative image when hovering.
								</li>
							</ol>
						</li>

						<li>
							<b>Content options</b> allows you to set a color scheme,
							subheading, heading and description for the section.
						</li>
					</ol>

					<h3 id="slideshow">Slideshow</h3>
					<p>
						The section allows you to add slides with image, heading,
						description and promo code.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/slideshow_1.png" />
					</figure>
					<figure>
						<img src="/assets/imgs/docs/force/slideshow_2.png" />
					</figure>
					<figure>
						<img src="/assets/imgs/docs/force/slideshow_3.png" />
					</figure>
					<ol>
						<li><b>Aspect ratio</b> sets the aspect ratio of the image.</li>
						<li>
							<b>Slider options</b> allow you to customize slider, switch loop
							mode, pagination, navigation, autoplay.
						</li>
						<li>
							Block <b>Slide</b> option<b> Image</b> allows you to set a image
							for the slide.
						</li>
						<li>
							Block <b>Slide</b> option<b> Heading</b> allows you to set a
							heading for the slide.
						</li>
						<li>
							Block <b>Slide</b> option<b> Description</b> allows you to set a
							description for the slide.
						</li>
						<li>
							Block <b>Slide</b> <b>Button options</b> allows you to set a
							button and customize it.
						</li>
					</ol>

					<h3 id="multicolumn">Multicolumn</h3>
					<p>This section allows you to add multiple columns of content.</p>
					<figure>
						<img src="/assets/imgs/docs/force/multicolumn_1.png" />
					</figure>
					<ol>
						<li>
							<b>Main options</b> allows you to set a heading , heading size ,
							subheading and header alignment.
						</li>
						<li>
							<b>Columns per row</b> allows you to select the number of columns
							in one row.
						</li>
						<li>
							<b>Enable swipe for mobile</b> allows you to display this section
							as slider on mobile.
						</li>
						<li>
							Each <b>Column block</b> includes settings that allow you to
							configure the column's content and image.
						</li>
					</ol>

					<h3 id="collapsible-content">Collapsible Content</h3>
					<p>
						You can add and customize a collapsible content section, such as
						using it for FAQs.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/collapsible_content_1.png" />
					</figure>
					<figure>
						<img src="/assets/imgs/docs/force/collapsible_content_2.png" />
					</figure>
					<ol>
						<li>
							For each collapsible row block, you can set a
							<b>Heading</b> (question) that will always be displayed and a
							collapsible <b>Description</b> (answer).
						</li>
						<li>You can also choose special rows to be opened by default.</li>
					</ol>

					<h3 id="collection-grid">Collection Grid</h3>
					<p>
						This section allows you to add a grid of cards with background image
						or video and texts.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/collection_grid_1.png" />
					</figure>
					<ol>
						<li>
							<b>Content options</b><br />
							<ol>
								<li>
									<b>Heading</b> allows you to add a heading for the section.
								</li>
								<li>
									<b>Heading size</b> allows you to customize the size of the
									heading (e.g. small, medium, large).
								</li>
								<li>
									<b>Enable magnetic hover effect</b> allows you to add a hover
									animation that creates a “magnetic” movement effect on the
									heading or content.
								</li>
							</ol>
						</li>

						<li>
							<b>Collection Block</b><br />
							<ol>
								<li>
									<b>Heading</b> allows you to add a heading for the section.
								</li>
								<li>
									<b>Heading size</b> allows you to customize the size of the
									heading (e.g. small, medium, large).
								</li>
								<li>
									<b>Enable magnetic hover effect</b> allows you to add a hover
									animation that creates a “magnetic” movement effect on the
									heading or content.
								</li>
							</ol>
						</li>
					</ol>

					<h3 id="promo-banner">Promo Banner</h3>
					<p>
						The section allows you to add slides with image, heading and
						description.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/promo_banner_1.png" />
					</figure>
					<figure>
						<img src="/assets/imgs/docs/force/promo_banner_2.png" />
					</figure>
					<ol>
						<li>
							<b>Image options</b><br />
							<ol>
								<li>
									<b>Image</b> allows you to add a background image for the
									promo banner.
								</li>
								<li>
									<b>Image ratio</b> allows you to set the proportion of the
									image (e.g. square, portrait, landscape).
								</li>
								<li>
									<b>Opacity</b> allows you to adjust the transparency level of
									the image.
								</li>
							</ol>
						</li>
						<li>
							<b>Countent options</b> allows you to adjust
							<b>Countdown settings</b> , <b>Heading settings</b><br />
							<ol>
								<li>
									<b>End date</b> allows you to set the date when the countdown
									will end.
								</li>
								<li>
									<b>End time</b> allows you to set the exact time when the
									countdown will end.
								</li>
								<li>
									<b>Text after countdown</b> allows you to define the text that
									will appear after the countdown reaches zero.
								</li>
								<li>
									<b>Label</b> allows you to customize the label text for the
									countdown.
								</li>
								<li>
									<b>Link</b> allows you to set a URL or action that will be
									triggered after the countdown ends.
								</li>
							</ol>
						</li>
						<li>
							<b>Ticker options</b> allows you to adjust ticker settings<br />
						</li>
					</ol>

					<h3 id="before-after">Before / After</h3>
					<p>Showcase compelling visual comparisons with this section.</p>
					<figure>
						<img src="/assets/imgs/docs/force/before_after_1.png" />
					</figure>
					<figure>
						<img src="/assets/imgs/docs/force/before_after_2.png" />
					</figure>
					<ol>
						<li>
							<b>Image options</b> allow you to set "before" and "after" images,
							a label for each image, as well as the aspect ratio for the image
							container.
						</li>
						<li>
							<b>Before options</b> , <b>After options</b> let you set and
							configure the display of the text, secondary text, and image.
						</li>
						<li>
							<b>Products options</b> allow you to select and display a list of
							products in the section. This section can be used to highlight the
							benefits of these products.
						</li>
					</ol>

					<h3 id="featured-blog">Featured Blog</h3>
					<p>
						The section allows you to select a blog and display its blog posts.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/featured_blog_1.png" />
					</figure>
					<ol>
						<li>
							<b>Blog</b> field allows you to choose a blog which posts will be
							displayed.
						</li>
						<li>
							<b>Blog posts count</b> allows you to set how many blog posts will
							be displayed.
						</li>
						<li>
							<b>Columns per row</b> allows you to define how many blog posts
							will be displayed in a single row.
						</li>
						<li>
							<b>Show featured image</b> allows you to display the featured
							image of each blog post.
						</li>

						<li>
							<b>Mobile layout:</b> <br />
							<ol>
								<li>
									<b>Number of columns</b> allows you to set how many columns
									will be displayed on mobile devices.
								</li>
								<li>
									<b>Enable swipe</b> allows users to scroll or swipe through
									items on mobile devices.
								</li>
							</ol>
						</li>
					</ol>

					<h3 id="featured-ticker">Featured Ticker</h3>
					<p>
						Showcase your partners or affiliations with this section. This
						section is perfect for building credibility and showcasing key
						partnerships effectively.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/featured_ticker_1.png" />
					</figure>
					<ol>
						<li>
							<b>Ticker speed</b> allows you to adjust the scrolling speed of
							the ticker content.
						</li>
						<li>
							<b>Pause on hover</b> allows the ticker animation to pause when
							the user hovers over it.
						</li>
					</ol>

					<h3 id="collections-list">Collections List</h3>
					<p>Displays a list of featured collections.</p>
					<figure>
						<img src="/assets/imgs/docs/force/collections_list_1.png" />
					</figure>
					<ol>
						<li>
							<b>Mobile layout</b> allows you to select the layout of the slider
							on mobile devices.
						</li>
						<li>
							<b>Image ratio</b> allows you to set the aspect ratio of the
							image.
						</li>
						<li>
							<b>Image fit</b> allows you to set the object fit for the image.
						</li>
						<li>
							<b>Collection</b> block allows you to select collection and
							customize it. Includes following options:<br />
							<ol>
								<li><b>Collection</b> allows you to select collection.</li>
								<li>
									<b>Image</b> field allows you to overwrite collection's
									featured image.
								</li>
							</ol>
						</li>
					</ol>

					<h3 id="countdown">Countdown</h3>
					<p>
						You can add and customize a countdown timer. If you add an image,
						this section will be displayed as two blocks; otherwise, it will be
						displayed as a single block.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/countdown_1.png" />
					</figure>
					<ol>
						<li>
							<b>Image</b> allows you to upload and display a background image
							for the section or block.
						</li>
						<li>
							<b>Opacity</b> allows you to adjust the transparency of the
							background image.
						</li>
						<li>
							The <b>End year</b>, <b>End month</b>, <b>End day</b>,
							<b>End hour</b> and <b>End minutes</b> options allow you to set
							the countdown's end date and end time.
						</li>
						<li>
							<b>After the timer ends</b> allows you to specify what should
							happen when the countdown is completed: either the section will be
							hidden, or a special text will be displayed.
						</li>
						<li>
							<b>Text after the timer ends</b> will be shown if the
							<i>Show text</i> option is selected.
						</li>
					</ol>

					<h3 id="product-carousel">Popular Products</h3>
					<p>
						The section allows you to display popular products and customize
						their display.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/popular_products_1.png" />
					</figure>
					<figure>
						<img src="/assets/imgs/docs/force/popular_products_2.png" />
					</figure>
					<figure>
						<img src="/assets/imgs/docs/force/popular_products_3.png" />
					</figure>
					<ol>
						<li>
							<b>Products</b> setting allows you to manually select specific
							products that will be displayed in the section instead of
							automatically pulling them from a collection.
						</li>
						<li>
							<b>Collection</b> setting allows you to select one or multiple
							collections. Each chosen collection will appear as a tab that acts
							as a filter, and when switching between tabs, the products from
							the corresponding collection will be displayed.
						</li>
						<li>
							<b>Product card type</b> setting allows you to change the style or
							layout of the product card (for example: standard card, list view,
							compact view), so you can control how products are visually
							displayed in the section.
						</li>
						<li>
							<b>Featured card option</b><br />
							<ol>
								<li>
									<b>Show "Tax included"</b> allows you to display a note
									indicating that taxes are included in the product price.
								</li>
								<li>
									<b>Show "Shipping calculated at checkout"</b> allows you to
									display a note that shipping costs will be calculated during
									checkout.
								</li>
								<li>
									<b>Show dynamic checkout buttons</b> allows you to display
									additional checkout buttons (e.g. Buy Now, PayPal, Shop Pay)
									directly on the product card.
								</li>
								<li>
									<b>Show recipient information form for gift card products</b>
									allows you to enable a form where customers can enter
									recipient details when purchasing gift cards.
								</li>
								<li>
									<b>Show discount badge</b> allows you to display a badge
									highlighting discounts when a product is on sale.
								</li>
							</ol>
						</li>
					</ol>

					<h3 id="product-markers">Product Markers</h3>
					<p>
						The section allows you to mark products in the image and choose
						display position.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/product_markers_1.png" />
					</figure>
					<ol>
						<li>
							<b>Product marker block</b> allows you to select a product, image
							and set the position of its marker.
						</li>
						<li><b>Image ratio</b> sets the aspect ratio of the image.</li>
					</ol>

					<h3 id="products-slider">Products Slider</h3>
					<p>This section allows you to display a set of products.</p>
					<figure>
						<img src="/assets/imgs/docs/force/products_slider_1.png" />
					</figure>
					<ol>
						<li>
							<b>Show count on desktop</b> option allows you to display the
							product index (e.g. 1/10, 2/10) inside the slider when viewing on
							desktop. Each product will have its own number in the sequence.
						</li>
						<li>
							<b>Enable default count styles</b> option allows you to apply the
							predefined design for the product counter in the slider. With this
							setting enabled, the count will be automatically styled using the
							theme’s default styles, for example displayed in the tertiary
							color.
						</li>
					</ol>

					<h3 id="testimonials">Testimonials</h3>
					<p>
						This section allows you to add and customize testimonials (clients
						reviews).
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/testimonials_1.png" />
					</figure>
					<figure>
						<img src="/assets/imgs/docs/force/testimonials_2.png" />
					</figure>
					<ol>
						<li>
							<b>Main options</b> allows you to set a color scheme, heading and
							description for the section and customize it.
						</li>
						<li>
							<b>Testimonials slide</b> block allows you to add and customize
							testimonials (clients reviews). Each block has the following
							options:<br />
							<ol>
								<li>
									<b>Product</b> allows you to set a product that is related to
									the review.
								</li>
								<li><b>Image</b> allows you to display image.</li>
								<li><b>Text</b> allows you to set a text of the review.</li>
								<li>
									<b>Author's name</b> allows you to set the name of the author
									of the review.
								</li>
								<li><b>Review score</b> allows you to set a review score.</li>
							</ol>
						</li>
					</ol>

					<!------------------------------ SECTIONS (END) ------------------------------>

					<!------------------------------ PAGES (START) ------------------------------>

					<h2 id="page">Pages</h2>

					<p>Information on theme pages.</p>

					<h3 id="product-page">Product Page</h3>

					<h4 id="product-information">Product Information</h4>
					<p>
						The Product information section allows users to view all relevant
						information about the product.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/product_information_1.png" />
					</figure>
					<ol>
						<li>
							With the <b>Aspect ratio</b> setting, you can set aspect ratios
							for the main images in the gallery.
						</li>
						<li>
							<b>Product metafields</b> allows you to add custom metafields to a
							product. These metafields can store additional information such as
							badges, custom labels, specifications, or any other custom content
							that can be displayed on the product card or used in theme logic.
						</li>
						<ol>
							<li>
								Navigate to Settings > Metafields and metaobjects in the Admin
								panel > Select Products > Click the button "Add definition".
								<figure>
									<img src="/assets/imgs/docs/force/custom_badges_1.png" />
								</figure>
							</li>
							<li>
								Fill the fields. In the Name field enter "Badges" so that
								"custom.badges" appears in the Namespace and Key field. In the
								Select type field select "Single line text" and "List of
								values."
								<figure>
									<img src="/assets/imgs/docs/force/custom_badges_2.png" />
								</figure>
							</li>
							<li>
								Navigate to the product and add information below.
								<figure>
									<img src="/assets/imgs/docs/force/custom_badges_3.png" />
								</figure>
							</li>
							<li>
								After adding the "Badges" metafield, you can also add the
								following metafields:
								<figure>
									<img src="/assets/imgs/docs/force/metafields_product_1.png" />
								</figure>
								<ol>
									<li>
										<b>Short description</b> – set the type to
										<i>Single line text</i>. This field allows you to add a
										brief description for the product.
										<figure>
											<img
												src="/assets/imgs/docs/force/metafields_product_3.png"
											/>
										</figure>
									</li>
									<li>
										<b>Specs</b> – set the type to <i>JSON</i>. This field
										allows you to store structured specifications or technical
										details for the product.
										<figure>
											<img
												src="/assets/imgs/docs/force/metafields_product_2.png"
											/>
										</figure>
									</li>
									<li>
										<b>Warranty, Safety Information, User Manual</b> metafields
										allow you to add additional product information in the form
										of PDF files. These can include warranty details, safety
										instructions, or user manuals that customers can download or
										view.
										<figure>
											<img
												src="/assets/imgs/docs/force/metafields_product_4.png"
											/>
										</figure>
									</li>
								</ol>
							</li>
						</ol>
					</ol>

					<h4 id="product-recommendations">Product Recommendations</h4>
					<p>
						Dynamic recommendations use order and product information to change
						and improve over time.
					</p>
					<p>
						To add and edit product recommendations, install the
						<b>Search & Discovery app</b> by Shopify from the Apps page in the
						Admin panel. Once installed, open the app and follow the
						"Recommendations" link in the Feature overview section to add
						recommendations to your products.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/product_recommendations_1.png" />
					</figure>

					<p>Settings for this section look like below:</p>
					<figure>
						<img src="/assets/imgs/docs/force/product_recommendations_2.png" />
					</figure>
					<ol>
						<li><b>Heading</b> allows you to set a heading for the section.</li>
						<li>
							<b>Heading size</b> selector field allows you to change the size
							of the section header.
						</li>
						<li>
							<b>Product card</b> options allow you to customize product cards
							in the section.
						</li>
					</ol>

					<h4 id="variant-picker">Variant Picker</h4>
					<p>
						You can choose between two types for the Variant Picker: Pills and
						Dropdown.
					</p>

					<h4 id="variant-picker-pills">Pills</h4>
					<p>
						Pills display options as buttons. In this type, the color option can
						be shown as <a href="#color-swatches">Color swatches</a>.
					</p>
					<figure>
						<img src="/assets/imgs/docs/force/picker_pills_1.png" />
					</figure>

					<h4 id="variant-picker-dropdown">Dropdown</h4>
					<p>Dropdown allows variant selection through dropdown options.</p>
					<figure>
						<img src="/assets/imgs/docs/force/picker_dropdown_1.png" />
					</figure>

					<h3 id="collections-page">Collections Page</h3>
					<figure>
						<img src="/assets/imgs/docs/force/collection_page_1.png" />
					</figure>

					<h4 id="collection-banner">Collection Banner</h4>

					<ol>
						<li><b>Show collection image</b> field turn on image display.</li>
						<li>
							<b>Image for "Products" page</b> image for automatically generated
							page with all products.
						</li>
					</ol>

					<h4 id="product-grid">Product Grid</h4>
					<ol>
						<li>
							<b>Products per page</b> field sets the number of displayed cards.
						</li>
						<li>
							<b>Product card</b> options allow you to customize product cards
							in the section.
						</li>
						<li><b>Enable filtering</b> field turn filtering.</li>
						<li><b>Enable sorting</b> field turn sorting.</li>
					</ol>

					<h3 id="cart">Cart</h3>
					<figure>
						<img src="/assets/imgs/docs/force/cart_page_1.png" />
					</figure>

					<h4 id="cart-shipping">Free shipping message</h4>
					<p>
						To add and edit cart free shipping progress bar, follow these steps:
					</p>
					<ol>
						<li>
							Enable the Theme settings > Cart > Free shipping message > Show
							free shipping message.
						</li>

						<li>
							Set the value required to qualify for free shipping. This value
							should be specified in the store's default currency. For customers
							using other currencies, conversion will be applied.
						</li>

						<li>
							Create a
							<a
								href="https://help.shopify.com/en/manual/discounts/discount-types/free-shipping"
								target="_blank"
								>free shipping discount</a
							>
							in the store and set the same amount, or configure a
							<a
								href="https://help.shopify.com/en/manual/fulfillment/setup/shipping-rates/flat-shipping-rates#create-free-shipping-rates"
								target="_blank"
								>shipping rate</a
							>.
						</li>

						<li>
							To create and edit a shipping rate, go to the store settings under
							the Shipping and delivery tab.
						</li>
					</ol>

					<h3 id="blog">Blog</h3>
					<figure>
						<img src="/assets/imgs/docs/force/blog_page_1.png" />
					</figure>
					<ol>
						<li>
							<b>Posts per page</b> slider allows you to change the number of
							posts per page.
						</li>
						<li>
							<b>Blog posts count</b> slider allows you to select the number of
							posts in one row.
						</li>
						<li>
							<b>Blog post card</b> allows you to customize post's image and
							content.<br />
							Blog post card includes:<br />
							<ol>
								<li>
									<b>Show image</b> allows you to show or hide post's image.
								</li>
								<li>
									<b>Image ratio</b> allows you to choose the orientation of
									pictures for cards.
								</li>
								<li>
									<b>Image fit</b> allows you to choose the fit of pictures for
									cards.
								</li>
								<li>
									<b>Title font size</b> allows you to select the size of the
									post's title.
								</li>
								<li>
									<b>Show date</b> allows you to show or hide post's date of
									publication in post card.
								</li>
								<li>
									<b>Show tags</b> allows you to show or hide post's tags in
									post card.
								</li>
								<li>
									<b>Show author</b> allows you to show or hide post's author in
									post card.
								</li>
								<li>
									<b>Show excerpt</b> allows you to show or hide post's excerpt
									in post card.
								</li>
								<li>
									<b>Show comments count</b> allows you to show or hide comments
									count in post card.
								</li>
							</ol>
						</li>
						<li>
							<b>Featured post</b> block has following options:<br />
							<ol>
								<li><b>Post</b> allows you to select a post.</li>
								<li>
									<b>Color scheme</b> allows you to select the color scheme for
									the block.
								</li>
								<li>
									<b>Overlay opacity</b> allows you to change the opacity of the
									image overlay.
								</li>
							</ol>
						</li>
					</ol>

					<h3 id="blog-post">Blog Post</h3>
					<figure>
						<img src="/assets/imgs/docs/force/blogpost_1.png" />
					</figure>
					<ol>
						<li>
							This section contains 4 block types:<br />
							<ol>
								<li><b>Article header</b></li>
								<li><b>Content</b></li>
								<li><b>Article footer</b></li>
								<li><b>Sidebar</b></li>
							</ol>
						</li>
						<li>
							<b>Article header</b> block has following options:
							<ol>
								<li>
									<b>Image ratio</b> selector allows you to choose the aspect
									ratio of the post's feature image.
								</li>
								<li>
									<b>Show date</b> allows you to show or hide post's date of
									publication in article's header.
								</li>
								<li>
									<b>Show author</b> allows you to show or hide post's author in
									article's header.
								</li>
								<li>
									<b>Show tags</b> allows you to show or hide post's tags in
									article's header.
								</li>
							</ol>
						</li>
						<li>
							<b>Article footer</b> block has following options:
							<ol>
								<li>
									<b>Show author</b> allows you to show or hide post's author in
									article's footer.
								</li>
								<li>
									<b>Show tags</b> allows you to show or hide post's tags in
									article's footer.
								</li>
								<li>
									<b>Show date</b> allows you to show or hide post's date of
									publication in article's footer.
								</li>
								<li>
									<b>Share</b> options allows you to enable share block and each
									share link from the list.
								</li>
							</ol>
						</li>
						<li>
							<b>Sidebar</b> block allows you to display the next post and
							customize its card, select a list of products and show them in the
							sidebar, and add a promo banner.
						</li>
					</ol>

					<!------------------------------ DEMOS (END) ------------------------------>

					<!------------------------------ SUPPORT ------------------------------>

					<h2 id="support">Support</h2>

					<p>
						You can ask any questions about the theme and our support agent will
						help you within 24 hours on business days.
					</p>
					<router-link to="/help-center/" class="sh-link-arrow">
						<span class="sh-link-arrow__name">Visit Help Center</span>
						<span class="sh-link-arrow__icon">
							<svg
								viewBox="0 0 24 25"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M16.004 9.914L7.39697 18.521L5.98297 17.107L14.589 8.5H7.00397V6.5H18.004V17.5H16.004V9.914Z"
									fill="currentColor"
								></path>
							</svg>
						</span>
					</router-link>
					&nbsp;&nbsp;&nbsp;&nbsp;
					<router-link to="/privacy/" class="sh-link-arrow">
						<span class="sh-link-arrow__name">View Terms & Conditions</span>
						<span class="sh-link-arrow__icon">
							<svg
								viewBox="0 0 24 25"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M16.004 9.914L7.39697 18.521L5.98297 17.107L14.589 8.5H7.00397V6.5H18.004V17.5H16.004V9.914Z"
									fill="currentColor"
								></path>
							</svg>
						</span>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
@import "@/assets/scss/_documentation.scss";
</style>

<script setup>
import { onMounted } from "vue";

onMounted(() => {
	const sidebar = document.querySelector(
		".sh-documentation-theme__sidebar-nav"
	);

	if (!sidebar) return;

	sidebar.addEventListener("click", (e) => {
		const link = e.target.closest("a");
		if (!link || !link.hash) return;

		const targetId = link.hash.slice(1);
		const targetElement = document.getElementById(targetId);
		if (!targetElement) return;

		e.preventDefault();

		const targetPosition =
			targetElement.getBoundingClientRect().top + window.pageYOffset;
		window.scrollTo({
			top: targetPosition - 32,
			behavior: "smooth",
		});
	});
});
</script>
